module.exports = __webpack_public_path__ + "static/media/logo3.61a8d063.jpg";